import { InspectorControls, useBlockProps } from '@wordpress/block-editor';
import { useEffect, useState } from '@wordpress/element';
import { PanelBody, SelectControl } from '@wordpress/components';
import {fetchCards, fetchTerms, removeHtmlTags} from '../../index';
import Splide from '@splidejs/splide';
import {v4 as uuidv4} from 'uuid';


export const Edit = ({ attributes, setAttributes }) => {
    const {cardType, carouselsData, cards, styleType,} = attributes;
    const blockProps = useBlockProps();

    let [carouselTypeOpts, setCarouselTypeOpts] = useState([]);
    let [carouselId, setCarouselId] = useState('carousel_' + uuidv4())

    useEffect(() => {
        const loadTerms = async () => {
            const terms = await fetchTerms();
            setAttributes({ terms: terms });

            let options = terms.map((term) => {
                let label = term['name'].charAt(0).toUpperCase() + term['name'].slice(1);
                term = { label: label, value: JSON.stringify(term) };
                return term;
            });
            setCarouselTypeOpts(options);

            console.log(carouselTypeOpts);
        };

        loadTerms();
    }, []);

    useEffect(() => {
        const loadCards = async () => {
            const fetchedCards = await fetchCards(cardType);
            setAttributes({ cards: fetchedCards });
        };

        loadCards();
    }, [cardType]);

    useEffect(() => {
        const initializeCarousel = () => {
            const carouselElement = document.getElementById(carouselId);
            console.log(carouselElement)
            if (carouselElement) {
                if (carouselElement.splide) {
                    carouselElement.splide.destroy();
                }
                new Splide(carouselElement, carouselsData[`${styleType}s-carousel`].options).mount();
                setAttributes({'carouselId' : carouselId})
            }
        };

        initializeCarousel();
    }, [cards, cardType, styleType]);

    const classNames = {
        list: `${styleType}s-list`,
        card: `${styleType}-card`,
        imageWrap: `${styleType}-image-wrap`,
        image: `${styleType}-image`,
        title: `${styleType}-title`,
        content: `${styleType}-content`
    };

    return (
        <div {...blockProps}>
            <InspectorControls>
                <PanelBody title="Settings">
                    <SelectControl
                        label="Card Type"
                        value={JSON.stringify(cardType)}
                        options={carouselTypeOpts}
                        onChange={(value) => setAttributes({ cardType: JSON.parse(value) })}
                    />

                    <SelectControl
                        label="Cards Style"
                        value={styleType}
                        options={[
                            { label: 'Image - Title', value: 'experience' },
                            { label: 'Image - Title - Black Overlay', value: 'traveltype' },
                            { label: 'Image - Title - Text', value: 'review' },
                        ]}
                        onChange={(value) => setAttributes({ styleType: value })} // Aggiorna setAttributes qui
                    />
                </PanelBody>
            </InspectorControls>
            <div className="splide carousel-wrap" id={carouselId} data-configType = {`${styleType}s-carousel`}>
                <div className="splide__track">
                    <div className={`splide__list ${classNames.list}`} id={`${carouselId}_list`}>
                        {cards.map((card) => (
                            <div key={card.id} className={`splide__slide ${classNames.card}`}>
                                {styleType === 'traveltype'
                                    && (<div className="background-overlay black-overlay"></div>)
                                }
                                <figure className={`slide-image-wrap ${classNames.imageWrap}`}>
                                    {card.featured_media && (
                                        <img
                                            className={`slide-image ${classNames.image}`}
                                            src={card._embedded['wp:featuredmedia'][0].source_url}
                                            alt={card.title.rendered}
                                        />
                                    )}
                                </figure>

                                {styleType !== 'review' ? (
                                    <h3 className={classNames.title}>{card.title.rendered}</h3>
                                ) : (
                                    <div className="review-content">
                                        <h3 className="review-title">{card.title.rendered}</h3>
                                        <p>{removeHtmlTags(card.content.rendered)}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
